import { render, staticRenderFns } from "./FbaBasketProduct.vue?vue&type=template&id=1654df44&scoped=true&"
import script from "./FbaBasketProduct.vue?vue&type=script&lang=js&"
export * from "./FbaBasketProduct.vue?vue&type=script&lang=js&"
import style0 from "./FbaBasketProduct.vue?vue&type=style&index=0&id=1654df44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1654df44",
  null
  
)

export default component.exports